// src/components/flight-data/ConnectionParametersInfo.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import { colorToRGB } from '../../utils/connectionUtils';

/**
 * Reusable component for displaying the connection parameters
 * @param {Object} props
 * @param {Object} props.params - Connection parameters
 * @param {string} props.color - Primary color for the box
 * @param {string} props.extraInfo - Optional additional info text
 */
function ConnectionParametersInfo({ params, color, extraInfo }) {
  return (
    <Box sx={{ marginBottom: '1rem', backgroundColor: `rgba(${colorToRGB(color)}, 0.1)`, padding: '1rem', borderRadius: '4px' }}>
      <Typography sx={{ color, fontWeight: 'bold' }}>
        Connection Parameters
      </Typography>
      <Typography sx={{ color: '#fff' }}>
        {params.isPriorityFlight 
          ? "Priority Flight: Connections ≤60 minutes highlighted in gold" 
          : `Hot Bags: Connections ≤ ${params.hotThreshold} minutes highlighted in red`}
      </Typography>
      <Typography sx={{ color: '#fff' }}>
        Cold Bags: Connections ≥ {params.coldThresholdHours} hours highlighted in blue
      </Typography>
      {extraInfo && (
        <Typography sx={{ color: '#fff' }}>
          {extraInfo}
        </Typography>
      )}
    </Box>
  );
}

export default ConnectionParametersInfo;